import {
  NodeTypeEnum,
  StorageDurationEnum,
  StorageManagedByEnum,
  TransportManagedByEnum,
  TypeOfClientsEnum,
  WeightOptionEnum,
} from '@shared/api/types';
import { z } from 'zod';

export const distributionFlowSchema = z
  .object({
    name: z.string().optional(),
    typeOfClients: z.nativeEnum(TypeOfClientsEnum),
    type: z.literal('distribution').default('distribution'),
    weight: z.coerce
      .number({ invalid_type_error: 'Enter a number' })
      .min(0, 'Weight must be at least 0'),
    weightOption: z.nativeEnum(WeightOptionEnum),
    coldChainPercentage: z.coerce
      .number({ invalid_type_error: 'Enter a number' })
      .min(0, 'Must be at least 0')
      .max(100, 'Must be at most 100'),
    segments: z.array(
      z.object({
        nodeName: z.string().optional(),
        nodeType: z.nativeEnum(NodeTypeEnum),
        storageManagedBy: z.nativeEnum(StorageManagedByEnum),
        distance: z.coerce.number().min(1, 'Distance is required'),
        transportMode: z.string().min(1, 'Transport mode is required'),
        transportManagedBy: z.nativeEnum(TransportManagedByEnum),
        storageDuration: z.nativeEnum(StorageDurationEnum),
      })
    ),
  })
  .superRefine((val, ctx) => {
    const { weightOption, weight } = val;
    if (weightOption !== WeightOptionEnum['total_weight'] && weight > 100) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_big,
        path: ['weight'],
        maximum: 100,
        type: 'number',
        inclusive: true,
        message: 'Weight must be at most 100',
      });
    }
  });
